<template>
  <li class="vr360-app__my-streams__list__item">
    <a href="stream" @click.prevent="showStream" class="vr360-app__my-stream">
      <div class="vr360-stream-stub vr360-app__my-stream__poster">
        <!-- <img src="images/common/stream-1.jpg" alt=""> -->
        <template  v-if="stream.poster">
          <img :src="stream.poster | storagePath" alt="">
        </template>
        <!-- <span class="vr360-text-caption vr360-text-white">{{stream.duration | secondsTohhmmss }}</span> -->
      </div>

      <div class="vr360-app__my-stream__desc">
        <p class="vr360-head-reg vr360-app__my-stream__desc__name">
          {{stream.title}}
        </p>
        <p class="vr360-app__my-stream__desc__views">
          <span class="vr360-text-caption vr360-text-gray-2">{{stream.watched | views}}</span>
          <i class="vr360-icon bg-lock" v-if="stream.private"></i>
        </p>
      </div>
    </a>
  </li>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "item-my-stream",
  props: {
    stream: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions({
      toggleLikeStream: "stream/toggleLikeStream",
      selectStream: "stream/selectStream",
      setPositionScrollY: "setPositionScrollY"
    }),
    showStream(e) {
      e.preventDefault();
      this.setPositionScrollY(this.getScrollBlock.scrollTop);
      this.selectStream(this.stream.id);
      this.$router.push({
        name: "ItemMyStream",
        params: { id: this.stream.id }
      });
    },
    toggleLike() {
      this.toggleLikeStream(this.stream._id);
    }
  },
  filters: {
    views(val) {
      return val > 1 ? `${val} views` : `${val} view`;
    }
  },
  computed: {
    ...mapGetters({
      getScrollBlock: "getScrollBlock"
    })
  }
};
</script>

<style lang="scss">
</style>
